var _defs, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponent551(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 307.417,
    height: 306.935,
    viewBox: "0 0 307.417 306.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#71c9f0;}.a,.e{opacity:0.78;}.b,.c,.f{fill:#fff;}.b{fill-rule:evenodd;}.d{opacity:0;}.e{fill:#005a80;}.f{font-size:20.922px;font-family:Gotham-Medium, Gotham;font-weight:500;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H206.93a100,100,0,0,1,100,100V306.93a0,0,0,0,1,0,0H100a100,100,0,0,1-100-100V0A0,0,0,0,1,0,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-271.141 -4384.073)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M487.5,4573.225a65.294,65.294,0,0,1-119.256,15.407,52.316,52.316,0,0,0,16.676.8c9.679,11.625,23.379,19.025,39.688,19.025a52.786,52.786,0,0,0,50.25-36.632,74.477,74.477,0,0,1,12.642,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M355.154,4578.81c45.124,26.465,79.062-34.257,118.124-33.52,26.222.5,36.612,13.359,36.612,13.359s-15.585-45.766-53.682-32.407c-31.84,11.165-66.465,61.039-101.054,52.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M442.355,4521.665s-17.193,9.4-28.819,20.162c-16.7,15.458-42.035,39.877-66.421,24.257-6.578-4.214-10.289-11.565-11.133-22.526,14.21,23.092,36.306,13.292,54.221,1.775,15.14-9.73,33.425-25.184,52.152-23.668Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M419.969,4578.933s23.268-18.722,44.148-23.418c19.874-4.469,51.311-1.179,48.991,34.3-5.014-26.109-46.056-23.883-65.556-19.913a148.192,148.192,0,0,0-27.583,9.029Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M431.913,4447.8c-2.084-2.84-3.956-5.345-5.565-7.464-1.6,2.119-3.473,4.624-5.557,7.464-16.476,22.411-46.2,65.7-61.42,105.547,4.123.264,8.977-.589,14.6-3.315,14.226-33.488,37.937-68.849,52.383-88.956a614.987,614.987,0,0,1,34.833,53.947q1.2,2.111,2.348,4.185a59.544,59.544,0,0,1,14.181.343C462.483,4490.864,443.773,4463.926,431.913,4447.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-1942.141 -4088.073)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-542 -296)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H206.93a100,100,0,0,1,100,100V306.93a0,0,0,0,1,0,0H100a100,100,0,0,1-100-100V0A0,0,0,0,1,0,0Z",
    transform: "translate(2484.628 4384.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2700.986,4573.225a65.294,65.294,0,0,1-119.256,15.407,52.312,52.312,0,0,0,16.675.8c9.68,11.625,23.38,19.025,39.688,19.025a52.787,52.787,0,0,0,50.25-36.632,74.489,74.489,0,0,1,12.643,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2568.641,4578.81c45.124,26.465,79.063-34.257,118.124-33.52,26.222.5,36.612,13.359,36.612,13.359s-15.585-45.766-53.681-32.407c-31.841,11.165-66.466,61.039-101.055,52.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2655.843,4521.665s-17.193,9.4-28.82,20.162c-16.7,15.458-42.035,39.877-66.42,24.257-6.578-4.214-10.29-11.565-11.133-22.526,14.21,23.092,36.3,13.292,54.221,1.775,15.14-9.73,33.425-25.184,52.152-23.668Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2633.456,4578.933s23.269-18.722,44.149-23.418c19.874-4.469,51.31-1.179,48.99,34.3-5.013-26.109-46.056-23.883-65.556-19.913a148.19,148.19,0,0,0-27.583,9.029Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2645.4,4447.8c-2.084-2.84-3.957-5.345-5.566-7.464-1.6,2.119-3.472,4.624-5.556,7.464-16.476,22.411-46.2,65.7-61.42,105.547,4.123.264,8.976-.589,14.6-3.315,14.225-33.488,37.937-68.849,52.382-88.956a614.755,614.755,0,0,1,34.834,53.947q1.2,2.111,2.347,4.185a59.544,59.544,0,0,1,14.181.343C2675.97,4490.864,2657.261,4463.926,2645.4,4447.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0H206.93a100,100,0,0,1,100,100V306.93a0,0,0,0,1,0,0H100a100,100,0,0,1-100-100V0A0,0,0,0,1,0,0Z",
    transform: "translate(1942.628 4088.078)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(1972.762 4174.341)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.894,
    y: 20
  }, "Tahweel&apos;s policy and "), /*#__PURE__*/React.createElement("tspan", {
    x: 6.661,
    y: 45.106
  }, "applicable regulations "), /*#__PURE__*/React.createElement("tspan", {
    x: 23.179,
    y: 70.212
  }, "ensures no harmful "), /*#__PURE__*/React.createElement("tspan", {
    x: 31.872,
    y: 95.318
  }, "fumes/gasses are "), /*#__PURE__*/React.createElement("tspan", {
    x: 4.496,
    y: 120.424
  }, "discharged into the air")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent551);
export default __webpack_public_path__ + "static/media/Component55–1.8b4f8cd2aa77440661f197e192309db8.svg";
export { ForwardRef as ReactComponent };